import Noty from "noty";
import moment from "moment";
import ReactDOM from "react-dom";
import _ from "lodash";

export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const WARNING = "WARNING";

function generateRandomString(alphabet, length) {
	if (!length) length = 6;
	let retval = "";
	for (var i = 0; i < length; i++) {
		retval += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
	}
	return retval;
}

export default class Util {
	static notyError(msg) {
		new Noty({
			type: "error",
			layout: "topRight",
			text: msg,
			timeout: 4000,
			progressBar: false,
			closeWith: ["button"],
			animation: {
				open: "noty_effects_open",
				close: "noty_effects_close"
			},
			id: false,
			force: false,
			killer: false,
			queue: "global",
			container: false,
			buttons: [],
			sounds: {
				sources: [],
				volume: 1,
				conditions: []
			},
			titleCount: {
				conditions: []
			},
			modal: false
		}).show();
	}

	static notyWarning(msg) {
		new Noty({
			type: "warning",
			layout: "topRight",
			text: msg,
			timeout: 4000,
			progressBar: false,
			closeWith: ["button"],
			animation: {
				open: "noty_effects_open",
				close: "noty_effects_close"
			},
			id: false,
			force: false,
			killer: false,
			queue: "global",
			container: false,
			buttons: [],
			sounds: {
				sources: [],
				volume: 1,
				conditions: []
			},
			titleCount: {
				conditions: []
			},
			modal: false
		}).show();
	}

	static notySuccess(msg) {
		new Noty({
			type: "success",
			layout: "topRight",
			text: msg,
			timeout: 4000,
			progressBar: false,
			closeWith: ["button"],
			animation: {
				open: "noty_effects_open",
				close: "noty_effects_close"
			},
			id: false,
			force: false,
			killer: false,
			queue: "global",
			container: false,
			buttons: [],
			sounds: {
				sources: [],
				volume: 1,
				conditions: []
			},
			titleCount: {
				conditions: []
			},
			modal: false
		}).show();
	}

	static showNoty(result, messagge) {
		if (result === SUCCESS) {
			this.notySuccess(messagge);
		} else if (result === ERROR) {
			this.notyError(messagge);
		} else {
			this.notyWarning(messagge);
		}
	}

	static sortAtoZ(a, b) {
		if (a < b) return -1;
		if (a > b) return 1;
		return 0;
	}

	static formatDateTimeToISODateTime(date, time) {
		let returnValue = moment(date);
		let _time = moment(time);
		returnValue.set({
			hour: _time.get("hour"),
			minute: _time.get("minute")
		});
		return moment(returnValue).format("YYYY-MM-DDTHH:mm");
	}

	static formatDateToISODate(date) {
		let returnValue = moment(date);
		return moment(returnValue).format("YYYY-MM-DD");
	}

	static formatDateToShow(date) {
		return date ? moment(date).format("DD/MM/YYYY HH:mm") : null;
	}
	static formatDateToShowNotHour(date) {
		return date ? moment(date).format("DD/MM/YYYY") : "";
	}

	static isoDateTimeToJavascriptDate(date) {
		return date ? moment(date, "YYYY-MM-DDTHH:mm").toDate() : null;
	}

	static isoDateToJavascriptDate(date) {
		return date ? moment(date, "YYYY-MM-DD").toDate() : null;
	}

	static joinDataAndTime(date, time) {
		let _date = moment(date);
		let _time = moment(time);
		_date.set({
			hour: _time.get("hour"),
			minute: _time.get("minute")
		});
		return _date;
	}

	static formatDouble(double) {
		return double
			? double.toLocaleString("es-Es", {
					minimumFractionDigits: 2
				})
			: "0,00";
	}

	static formatPesos(double) {
		return double
			? `$ ${double.toLocaleString("es-Es", {
					minimumFractionDigits: 2
				})}`
			: "";
	}

	static parsePesos(double) {
		if (double) {
			let ocurrence = 0;
			return double
				.replace(" ", "")
				.replace("$ ", "")
				.replace("$", "")
				.replace(/,/g, match => {
					ocurrence++;
					return ocurrence === 2 ? "" : match;
				});
		}
	}

	static formatCuitToNumber(value) {
		return _.startsWith(value, "-", 2) ? value.split("-").join("") : value;
	}

	static buildQueryString(params = {}) {
		if (_.isString(params)) {
			return params.length ? "?" + params : params;
		}
		// transform it to string
		let queryString = "",
			arr = [],
			key,
			value;
		for (key in params) {
			value = params[key];
			if (value !== null && value !== undefined) {
				arr.push(key.toString() + "=" + value.toString());
			}
		}
		if (arr.length) {
			queryString = "?" + arr.join("&");
		}
		return queryString;
	}

	static hash(string) {
		return string
			.toString()
			.split("")
			.map(v => v.charCodeAt(0))
			.reduce((a, v) => (a + ((a << 7) + (a << 3))) ^ v)
			.toString(16);
	}

	static randomAlphaNum(length) {
		const alphabet =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		return generateRandomString(alphabet, length);
	}

	static randomAlpha(length) {
		const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
		return generateRandomString(alphabet, length);
	}

	static randomNum(length) {
		const alphabet = "0123456789";
		return generateRandomString(alphabet, length);
	}

	static isFileObject(object) {
		return object && {}.toString.call(object) === "[object File]";
	}
}

export function handleSubmitFail(errors) {
	if (!this.refs || !errors) {
		return;
	}
	const refsKeys = Object.keys(this.refs);
	const keys = Object.keys(errors);
	let key = null;
	let matchfound = false;
	refsKeys.filter(item => {
		if (keys.indexOf(item) > -1 && !matchfound) {
			key = item;
			matchfound = true;
			return false;
		} else {
			return true;
		}
	});
	this.targetNode = this.refs[key];
	if (this.targetNode) {
		const node = ReactDOM.findDOMNode(this.targetNode);
		if (node.getElementsByTagName("input")[0]) {
			node.getElementsByTagName("input")[0].focus();
			return;
		} else if (
			//Esto apunta a un SelectField,
			node.getElementsByTagName("div")[0].getElementsByTagName("button")[0]
		) {
			node
				.getElementsByTagName("div")[0]
				.getElementsByTagName("button")[0]
				.focus();
			return;
		} else {
			const parentNode = ReactDOM.findDOMNode(this);
			const xy = node.getBoundingClientRect();
			this.x = xy.right + window.scrollX;
			this.y = xy.top + window.scrollY - 120;
			(parentNode &&
				parentNode.scrollTo &&
				parentNode.scrollTo(this.x, this.y)) ||
				(parentNode &&
					parentNode.scrollTop &&
					(parentNode.scrollTop = this.y)) ||
				(window && window.scrollTo(this.x, this.y));
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/Util.js